import { useState } from "react";
import AppShell from "@/components/AppShell";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { PlaneTakeoff } from "lucide-react";
import { getSessionUser, saveLeaveRequest } from "@/lib/eisStore";

export default function ApplyLeave() {
  const user = getSessionUser() || {};
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reason, setReason] = useState("");
  const [leaveType, setLeaveType] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!leaveType || !fromDate || !toDate || !reason.trim()) {
      toast.error("Please fill in all fields");
      return;
    }

    saveLeaveRequest({
      teacherId: user.id,
      teacherName: user.name || "Teacher",
      teacherEmail: user.email || "",
      leaveType,
      fromDate,
      toDate,
      reason: reason.trim(),
    });

    setFromDate("");
    setToDate("");
    setReason("");
    setLeaveType("");
    toast.success("Leave request sent to management");
  };

  return (
    <AppShell>
      <div data-testid="apply-leave-page" className="space-y-6 max-w-2xl">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold" style={{ color: "#0b1f7a" }}>
            Apply for Leave
          </h2>
          <p className="text-slate-500 mt-1 text-sm">
            Send your leave request to management for approval.
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle style={{ color: "#0b1f7a" }}>Leave Request Form</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <Label>From Date</Label>
                  <Input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="mt-1"
                  />
                </div>
                <div>
                  <Label>To Date</Label>
                  <Input
                    type="date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    className="mt-1"
                  />
                </div>
              </div>

              <div>
                <Label>Leave Type</Label>
                <div className="mt-2 grid grid-cols-3 gap-2">
                  {["CL", "ML", "In-time"].map((type) => {
                    const active = leaveType === type;
                    return (
                      <Button
                        key={type}
                        type="button"
                        variant={active ? "default" : "outline"}
                        onClick={() => setLeaveType(type)}
                        className={active ? "bg-[#0b1f7a] text-white" : ""}
                      >
                        {type}
                      </Button>
                    );
                  })}
                </div>
              </div>

              <div>
                <Label>Reason</Label>
                <Textarea
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Write your reason for leave"
                  className="mt-1 min-h-32"
                />
              </div>

              <Button
                type="submit"
                className="rounded-full text-white"
                style={{ backgroundColor: "#0b1f7a" }}
              >
                <PlaneTakeoff size={16} className="mr-2" />
                Submit Request
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
